// AUTO-GENERATED by scripts/write-build-token.mjs at build time. Do not edit.
export const BUILD_TOKEN = 'cc57519e4d2e';
